import { PageRequest } from '@/core/request/PageRequest';
import { Moment } from 'moment';
import { ItemDeliveryDetailTypeEnum } from '../DeliveryMaterial/DeliveryMaterial.types';

export enum ReturnMaterialType {
  part = '1',
  consumable = '2',
}

export interface ReturnMaterialFormValues {
  companyId: number;
  returnDate: Moment;
  returnerId: number;
  receiverId: number;
  items: ReturnMaterialResponseList[];
}

export interface ReturnMaterialResponseList {
  companyId: number;
  complementId: number;
  complementItemId: number;
  workOrderId: number;
  description: string;
  licensePlate: string;
  dateDelivered: string;
  quantityDelivered: number;
  manufacturingCode: string;
  itemId: number;
  differentiator: string;
  returnedQuantity: number;
  type: ReturnMaterialType;
  costPrice?: number;
}

export interface MaterialReturnListRequest extends PageRequest {
  companyId?: number;
  search?: string;
  type?: ReturnMaterialType;
}

export interface MaterialReturnRequest {
  companyId: number;
  returnDate: string;
  returnerId: number;
  receiverId: number;
  returnedItems: ReturnedItems[];
}

export interface ReturnedItems {
  returnedQuantity: number;
  complementItemId: number | null;
  complementId: number;
  consumableId?: number;
  materialReturnId?: number;
}

export interface MaterialReturnResult {
  id: number;
  companyId: number;
  returnDate: string;
  returnerId: number;
  receiverId: number;
  returnedItems: ReturnedItems[];
}

export interface MaterialReturnResponse {
  result: MaterialReturnResult;
}

export interface MaterialReturnDetailItem {
  workOrderId: number;
  workOrderNumber: string;
  workOrderComplementId: number;
  description: string;
  licensePlate: string;
  internalCode: string;
  returnedQuantity: number;
  returnDate: string;
  manufacturingCode: string | null;
  type: ItemDeliveryDetailTypeEnum;
}

export interface MaterialReturnDetailResult {
  companyId: number;
  returnDate: string;
  returnerMan: number;
  returnerManName: string;
  receivedMan: number;
  receivedManName: number;
  itemReturnDetail: MaterialReturnDetailItem[];
}

export interface MaterialReturnDetail {
  result: MaterialReturnDetailResult;
}
